import { useSignal } from "@preact/signals-react";

import MenuItem from "./MenuItem";

function Menu({ dashMenu, openSidebar, isDesktop, viewportHeight }) {
  const currentMenu = useSignal(null);
  return (
    <div id="dash-menu" className="flex pt-5 z-30 w-full">
      <nav
        id="dash-menu-nav"
        className="flex flex-wrap content-start w-full tablet:flex-col tablet:flex-nowrap tablet:space-y-3 h-[calc(100vh-84px)] lg:h-[calc(100vh-114px)] overflow-y-auto pl-1.5 pr-1.5 scroll-style lg:items-center"
      >
        {dashMenu.map((item) => (
          <MenuItem
            item={item}
            key={item.name}
            openSidebar={openSidebar}
            isDesktop={isDesktop}
            currentMenu={currentMenu}
          />
        ))}
      </nav>
    </div>
  );
}

export default Menu;
